export function calculateRemainingBalance(amountDue: number, amountToApply: number) {
  return Math.max(
    0,
    Number((Number(amountDue || 0) - Number(amountToApply || 0)).toFixed(2))
  );
}

export function calculateCashChange(amountToApply: number, cashReceivedAmount: number | string | '') {
  const numericAmountToApply = Number(amountToApply || 0);
  const numericReceivedAmount = Number(cashReceivedAmount || 0);

  return Math.max(0, Number((numericReceivedAmount - numericAmountToApply).toFixed(2)));
}
